export type LineHeightType =
  | 'lineHeightDisplay'
  | 'lineHeightPageTitle'
  | 'lineHeightPageTitleBold'
  | 'lineHeightPageSubtitleMD'
  | 'lineHeightPageSubtitleMDBold'
  | 'lineHeightPageSubtitleSM'
  | 'lineHeightPageSubtitleSMBold'
  | 'lineHeightSectionTitleSM'
  | 'lineHeightSectionTitleSMBold'
  | 'lineHeightSectionTitleMD'
  | 'lineHeightSectionTitleMDBold'
  | 'lineHeightBodyTextLG'
  | 'lineHeightBodyTextLGBold'
  | 'lineHeightBodyTextMD'
  | 'lineHeightBodyTextMDBold'
  | 'lineHeightBodyTextSM'
  | 'lineHeightBodyTextSMBold'
  | 'lineHeightLabelLG'
  | 'lineHeightLabelLGBold'
  | 'lineHeightLabelMD'
  | 'lineHeightLabelMDBold'
  | 'lineHeightLabelSM'
  | 'lineHeightLabelSMBold'
  | 'lineHeightButtonTextLG'
  | 'lineHeightButtonTextMD'
  | 'lineHeightButtonTextSM';

export type TypographyType =
  | 'display'
  | 'pageTitle'
  | 'pageTitleBold'
  | 'pageSubtitleMD'
  | 'pageSubtitleMDBold'
  | 'pageSubtitleSM'
  | 'pageSubtitleSMBold'
  | 'sectionTitleMD'
  | 'sectionTitleMDBold'
  | 'sectionTitleSM'
  | 'sectionTitleSMBold'
  | 'bodyTextLG'
  | 'bodyTextLGBold'
  | 'bodyTextMD'
  | 'bodyTextMDBold'
  | 'bodyTextSM'
  | 'bodyTextSMBold'
  | 'labelLG'
  | 'labelLGBold'
  | 'labelMD'
  | 'labelMDBold'
  | 'labelSM'
  | 'labelSMBold'
  | 'buttonTextLG'
  | 'buttonTextMD'
  | 'buttonTextSM';

export const boldTypes = new Set<TypographyType>(
  Object.values([
    'pageTitleBold',
    'pageSubtitleMDBold',
    'pageSubtitleSMBold',
    'sectionTitleSMBold',
    'sectionTitleMDBold',
    'bodyTextLGBold',
    'bodyTextMDBold',
    'bodyTextSMBold',
    'labelLGBold',
    'labelMDBold',
    'labelSMBold',
  ])
);
